import Vue from "vue";

// Módulo de estado de las estadísticas de sincronización CRM (Zoho, etc.).
// Namespaced automáticamente por el nombre de fichero: "crmStats".
// Alimentado por el endpoint GET /zoho/getstadistics → { integration, totals, byDate }.

// mutation types (locales a este módulo)
const SET_INTEGRATION = "SET_INTEGRATION";
const SET_TOTALS = "SET_TOTALS";
const SET_BY_DATE = "SET_BY_DATE";
const SET_LOADING = "SET_LOADING";
const RESET = "RESET";

const initialState = () => ({
    integration: null, // { uuid, name }
    totals: [], // [{ module, created, updated }]
    byDate: [], // [{ date, created, updated }]
    loading: false,
});

// state
export const state = initialState();

// getters
export const getters = {
    integration: (state) => state.integration,
    totals: (state) => state.totals,
    byDate: (state) => state.byDate,
    loading: (state) => state.loading,
};

// mutations
export const mutations = {
    [SET_INTEGRATION](state, integration) {
        Vue.set(state, "integration", integration);
    },
    [SET_TOTALS](state, totals) {
        Vue.set(state, "totals", Array.isArray(totals) ? totals : []);
    },
    [SET_BY_DATE](state, byDate) {
        Vue.set(state, "byDate", Array.isArray(byDate) ? byDate : []);
    },
    [SET_LOADING](state, loading) {
        Vue.set(state, "loading", !!loading);
    },
    [RESET](state) {
        Object.assign(state, initialState());
    },
};

// actions
export const actions = {
    setStats({ commit }, payload = {}) {
        commit(SET_INTEGRATION, payload.integration || null);
        commit(SET_TOTALS, payload.totals || []);
        commit(SET_BY_DATE, payload.byDate || []);
    },
    setLoading({ commit }, value) {
        commit(SET_LOADING, value);
    },
    reset({ commit }) {
        commit(RESET);
    },
};
